export default "__VITE_ASSET__B7fiBjaN__"